import React from 'react'

const ProdctHeader = () => {
  return (
     <div className="about-header">
      <div className="about-overlay">
        <div className="about-content">
          <h1 className="about-title">Product Focus & Expertise
</h1>
          <p className="about-subtitle">
      Precision, Innovation, and Reliability at Every Stage
          </p>
        
        </div>
      </div>

      <svg className="about-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z" fill="#ffffff" />
      </svg>
    </div>
  )
}

export default ProdctHeader
